import { render, staticRenderFns } from "./IconLogo.vue?vue&type=template&id=3570151a&"
import script from "./IconLogo.vue?vue&type=script&lang=js&"
export * from "./IconLogo.vue?vue&type=script&lang=js&"
import style0 from "./IconLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports